import { BadgeCheck, Store } from "lucide-react";

export function VerifiedBusinessBadge({ className = "" }: { className?: string }) {
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border border-blue-400/40 bg-blue-500/10 px-2 py-0.5 text-[10px] font-semibold text-blue-500 dark:text-blue-300 ${className}`}
      title="Identity-verified business"
    >
      <BadgeCheck className="h-3 w-3" /> Verified Business
    </span>
  );
}

export function VerifiedStoreBadge({
  city,
  province,
  className = "",
  stacked = false,
}: {
  city?: string | null;
  province?: string | null;
  className?: string;
  stacked?: boolean;
}) {
  const loc = [city, province].filter(Boolean).join(", ");
  const Pill = (
    <span
      className={`inline-flex items-center gap-1 rounded-full border border-indigo-400/40 bg-indigo-500/10 px-2 py-0.5 text-[10px] font-semibold text-indigo-500 dark:text-indigo-300 ${className}`}
      title="Identity-verified physical store"
    >
      <Store className="h-3 w-3" /> Verified Store
      {!stacked && loc && <span className="ml-1 font-normal text-muted-foreground">— {loc}</span>}
    </span>
  );
  if (!stacked) return Pill;
  return (
    <span className="inline-flex flex-col items-start gap-0.5">
      {Pill}
      {loc && <span className="text-[10px] text-muted-foreground">{loc}</span>}
    </span>
  );
}
